import * as React from "react"
import DOMPurify from "dompurify";
import { classNames } from "../../utils"
import "./checkbox.scss"

interface ICheckBoxInputProps {
    checked: boolean
    content: string
    onClick: (event: React.MouseEvent) => void
    style?: React.CSSProperties
    warning?: boolean
    optional?: string
}

const CheckBoxInput: React.FC<ICheckBoxInputProps> = props => {
    const { checked, content, onClick, style, warning, optional } = props
    return (
        <div
            className={classNames({
                "app-checkbox": true,
                "app-checkbox--warning": warning
            })}
            style={style ? style : {}}
        >
            <div className={classNames({
                "app-checkbox__box": true,
                "app-checkbox__box--checked": checked
            })}
                onClick={onClick}
            ></div>
            <div className="app-checkbox__content">
                <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(content) }}></div>
                {optional && <div className="app-checkbox__optional"><i>*{optional}</i></div>}
            </div>
        </div>
    )
}

export default CheckBoxInput